/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Input, FormGroup, Col, Label, Alert } from 'reactstrap';
import Validator from '../../custom-classes/validator';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the form group of the person name
 */
class FormGroupNewName extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            validFirstName: true,
            validLastName: true,
            firstName: '',
            lastName: ''
        }; // Default value

        if(this.props.data)
        {
            this.state =
            {
                firstName: this.props.data.firstName,
                lastName: this.props.data.lastName,
                validFirstName: true,
                validLastName: true,
            }; // Default value
        }

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){

        if(typeof nextProps.data !== 'undefined'){
            this.setState({
                firstName: nextProps.data.firstName,
                lastName: nextProps.data.lastName,
            });
        }
    }


    /**
     * Action when the first name is typed
     * @param event
     */
    handleFirstNameChange(event){
        this.setState({firstName: event.target.value}, () => {
                // Check if password are equals and show error if not
                this.setState({validFirstName: Validator.isFirstNameValid(this.state.firstName)},
                    () => {
                        this.setState({validLastName: Validator.isLastNameValid(this.state.lastName)},
                            () => {
                                this.props.updateParent(this.state);
                                return this.state;
                            });
                    })
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    // Handles when the password retype is changed
    handleLastNameChange(event){
        this.setState({lastName: event.target.value}, () => {

            // Check if password are equals and show error if not
            this.setState({validFirstName: Validator.isLastNameValid(this.state.firstName)},
                () => {
                    this.setState({validLastName: Validator.isFirstNameValid(this.state.lastName)},
                        () => {
                            this.props.updateParent(this.state);
                            return this.state;
                        });
                })
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    // Render the form group
    render() {
        return (
            <div>
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="firstname">
                            <Translate id="register.firstname"/>
                        </Label>
                        <Input value={this.state.firstName} type="text" name="firstname" id="firstname" onChange={this.handleFirstNameChange} />
                    </Col>
                </FormGroup>
                {
                    !this.state.validFirstName ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.validFirstName}>
                                <Translate id="register.firstname-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="lastname">
                            <Translate id="register.lastname"/>
                        </Label>
                        <Input value={this.state.lastName} type="text" name="lastname" id="lastname" onChange={this.handleLastNameChange} />
                    </Col>
                </FormGroup>
                {
                    !this.state.validLastName ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.validLastName}>
                                <Translate id="register.lastname-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
            </div>
        )
    };
}

export default FormGroupNewName;


// WEBPACK FOOTER //
// ./src/components/forms/form-group-name.js